var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":"signatureModal","size":"lg","title":"Please sign here","ok-only":"","ok-variant":"secondary","hide-footer":""}},[_c('div',{staticClass:"col-12 mt-2"},[_c('VueSignaturePad',{ref:"signaturePad",attrs:{"id":"signature","width":"100%","height":"500px","options":{
          onBegin: () => {
            this.$refs.signaturePad.resizeCanvas();
          }
        }}}),_c('br'),_c('div',[_c('el-button',{on:{"click":_vm.save}},[_vm._v("Save")]),_c('el-button',{on:{"click":_vm.undo}},[_vm._v("Undo")]),_c('el-button',{on:{"click":_vm.clear}},[_vm._v("Clear")])],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }